/**
 * Email professionnel : local@domaine.tld avec TLD d’au moins 2 lettres.
 * Refuse les adresses sans extension (ex. admin@societe).
 */
const BUSINESS_EMAIL =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/;

export function isValidBusinessEmail(email: string): boolean {
  const normalized = email.trim();
  if (!normalized || normalized.length > 254) return false;
  return BUSINESS_EMAIL.test(normalized);
}
